import { EventParams, logEvent } from 'firebase/analytics';
import { useEffect } from 'react';
import { useLocation } from 'react-router';
import blogFirebaseStore from '../blogStores/blogFirebaseStore';

export const useBlogPageViewTracking = () => {
    const location = useLocation();

    useEffect(() => {
        if (blogFirebaseStore.blogFirebaseAnalytics) {
            logEvent(blogFirebaseStore.blogFirebaseAnalytics, 'page_view', {
                page_path: location.pathname,
            });
        }
    }, [location]);
};

/**
 * 클릭 로그를 남긴다
 * @param buttonName 버튼 이름
 * @param options 추가 옵션 (소문자 스케이크 케이스로 정의)
 */
export const logBlogClick = (buttonName: string, options: EventParams) => {
    if (blogFirebaseStore.blogFirebaseAnalytics) {
        logEvent(blogFirebaseStore.blogFirebaseAnalytics, 'click', {
            button_name: buttonName,
            ...options,
        });
    }
};
